define('views/draft-page-view',['jquery', 'utils/view', 'modules/overlay-box', 'server-settings'], function (
  $,
  View,
  OverlayBox,
  serverSettings
) {
  var DraftView = (function () {
    function DraftView() {}

    DraftView.prototype.init = function () {
      $('#convertToCart').on('click', this.openAsCart);
    };

    DraftView.prototype.openAsCart = function (event) {
      event.preventDefault();

      var ob = new OverlayBox($('#openAsCartPopup'), {});
      ob.setup();
      ob.load(function () {
        ob.show();
      });
    };

    return DraftView;
  })();

  return View('DraftView', function () {
    var df = new DraftView();

    df.init();
  });
});

